/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { HttpClient, HttpErrorResponse, HttpParams, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})

export class ManageForecastStateService {
  constructor(private readonly configService: ConfigService,
              private readonly http: HttpClient) {
  }

  /**
   * Get list of all Forecast State with Index.
   */
  getForecastStates(): any {
    return this.http.get<any[]>(`${this.configService.baseApiUrl}manage-forecast-state`)
    .pipe(catchError(myError => this.handleError(myError)));

  }

  /**
   * Add a new Forecast State into DB.
   * @param newValue users input.
   */
  addForecastState(newValue: string): any {
    const params = new HttpParams().set('newValue', newValue);
    return this.http.post(`${this.configService.baseApiUrl}manage-forecast-state`, null, {params})
    .pipe(catchError(myError => this.handleError(myError)));
  }

  /**
   * Delete a Forecast State from DB.
   * @param forecastStateId Value to delete.
   */
  deleteForecastState(forecastStateId: number): any {
    const params = new HttpParams().set('forecastStateId', forecastStateId);
    return this.http.delete(`${this.configService.baseApiUrl}manage-forecast-state`, {params})
    .pipe(catchError(myError => this.handleError(myError)));
  }

  /**
   * Updated a Forecast State.
   * @param newValue New Value to replace existing value.
   * @param forecastStateId existing data that will be modified.
   */
  updateForecastState(newValue: string, forecastStateId: number): any {
    const params = new HttpParams().set('newValue', newValue).set('forecastStateId', forecastStateId);
    return this.http.put(`${this.configService.baseApiUrl}manage-forecast-state`, null, {params})
    .pipe(catchError(myError => this.handleError(myError)));
  }

  /**
   * Handles the errors produced by the backend
   * @param errorResponse The error produced by the API to be handled by the frontend
   * @return void
   */
  handleError(errorResponse: HttpErrorResponse): any {
    let errorMessage = 'An unexpected error occurred';
    switch (errorResponse.status) {
      case HttpStatusCode.BadRequest: {
        if (errorResponse.error && errorResponse.error.message) {
          errorMessage = errorResponse.error.message;
        } else {
          errorMessage = 'Error getting forecast states.';
        }
        break;
      }
    }
    return throwError(errorMessage);
  }


}
